import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons';
import { ModalController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-checklist-enrollment',
    templateUrl: './checklist-enrollment.component.html',
    styleUrls: ['./checklist-enrollment.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class ApplicationPreChecklistEnrollmentComponent implements OnInit {
    constructor(private modalCtrl: ModalController) {}

    faExclamationCircle = faExclamationCircle;

    @Input() checklistMissing: any[];
    @Input() checklistComplete: any[];

    // always keep fn at bottom of definitions
    trackByIndex = (index: number): number => index;

    ngOnInit() {/* empty */}

    dismiss() {
        this.modalCtrl.dismiss();
    }
}
